import { Controller } from 'stimulus';
import cookie from '../helpers/cookie';
import localDb from '../helpers/localDb';

class CookieConsent extends Controller {
  connect() {
    this.storageType = 'cookie'; // 'localstorage'

    if (this.storageType === 'localstorage') {
      // If we didn't consent yet, we show the banner
      if (!localDb.get(this.data.get('name'))) {
        this.element.removeAttribute('hidden');
      }
    }

    this.notifyHeaderController();
  }

  onAcceptCookies() {
    this.element.style.display = 'none';

    if (this.storageType === 'cookie') {
      cookie.set(this.data.get('name'), true, this.data.get('lifetime-in-minutes'));
    } else if (this.storageType === 'localstorage') {
      localDb.set(this.data.get('name'), true, this.data.get('lifetime-in-minutes'));
    }

    this.notifyTagManagerController();

    this.notifyHeaderController();
  }

  notifyHeaderController() {
    const header = document.querySelector('[data-controller="header"]');

    if (!header) {
      return;
    }

    const component = this.application.getControllerForElementAndIdentifier(header, 'header');

    if (component && typeof component.checkHeaderOffsetAndScroll === 'function') {
      component.checkHeaderOffsetAndScroll();
    }
  }

  notifyTagManagerController() {
    const tagManager = this.application.getControllerForElementAndIdentifier(document.documentElement, 'tag-manager');

    if (tagManager && typeof tagManager.onAcceptCookies === 'function') {
      tagManager.onAcceptCookies();
    }
  }
}

CookieConsent.targets = [
  //
];

export default CookieConsent;
